// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"w1-z"};